import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as config from './aws-exports';
import Client from 'aws-appsync';
import Amplify, { Auth } from 'aws-amplify';
import { ApolloProvider } from '@apollo/react-hooks';
import { Rehydrated } from 'components';
import { InMemoryCache } from 'apollo-cache-inmemory';

window.Shopify = {
	currency: {
		rate: 1,
	},
};

Amplify.configure({
	Auth: {
		cookieStorage: {
			domain: config.AUTH_COOKIE_DOMAIN,
			expires: config.AUTH_COOKIE_EXPIRES,
			path: config.AUTH_COOKIE_PATH,
			secure: true,
			sameSite: 'none',
		},
		identityPoolId: config.AWS_COGNITO_IDENTITY_POOL_ID,
		region: config.AWS_COGNITO_REGION,
		userPoolId: config.AWS_COGNITO_USER_POOL_ID,
		userPoolWebClientId: config.AWS_COGNITO_USER_POOL_CLIENT_ID,
	},
	API: {
		endpoints: [
			{
				name: 'API_GATEWAY',
				endpoint: config.API_GATEWAY,
				custom_header: async () => {
					return { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` };
				},
			},
		],
	},
	aws_appsync_graphqlEndpoint: config.APPSYNC_ENDPOINT,
	aws_appsync_region: config.APPSYNC_REGION,
	aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
});

const cache = new InMemoryCache();
const client = new Client({
	auth: {
		jwtToken: async () => (await Auth.currentSession()).getAccessToken().getJwtToken(),
		type: config.APPSYNC_AUTH_TYPE,
	},
	region: config.APPSYNC_REGION,
	url: config.APPSYNC_ENDPOINT,
	disableOffline: true,
	cache,
});

ReactDOM.render(
	<ApolloProvider client={client}>
		<Rehydrated>
			<App />
		</Rehydrated>
	</ApolloProvider>,
	document.getElementById('app')
);
